import core_routes from "@/router/modules/core_routes"; 
import navision_module_routes from "./navision_module_routes";

export default [
    ...core_routes,
    ...navision_module_routes
]